import { useEffect } from 'react';

import { useNavigate } from 'react-router';

import Loader from '@/shared/ui/feedback/Spinner';

import { useTokenAuth } from './useTokenAuth';

export const TokenAuth = () => {
  const { isReady } = useTokenAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isReady) {
      navigate('/');
    }
  }, [isReady, navigate]);

  return (
    <div className='flex h-screen items-center justify-between'>
      <Loader />
    </div>
  );
};
